import { createSelector } from 'redux-bundler';
import { convertArea, convertDistance } from './measure-utils';
import { getArea, getDistance } from 'ol/sphere';
import { getLayer } from '../../openlayers-utils/layer-utilities';
import createInteraction from '../../openlayers-utils/interaction-creator';
import throttle from 'lodash/throttle';

// import { Style, Fill, Stroke, Circle } from "ol/style";
// import Point from "ol/geom/Point";
// // SET UP DISTANCE STUFF
// const distanceLayer = getLayer({
//   serviceType: "LocalVector",
//   visible: true,
//   geometryType: "LineString",
//   style: function (feature) {
//     const geom = feature.getGeometry();
//     const styles = [
//       new Style({
//         stroke: new Stroke({
//           color: "rgba(255, 255, 255, 0.9)",
//           width: 4,
//         }),
//       }),
//       new Style({
//         stroke: new Stroke({
//           color: "rgba(0, 0, 0, 0.8)",
//           lineDash: [4, 4],
//           width: 2,
//         }),
//       }),
//     ];
//     const start = geom.getFirstCoordinate();
//     styles.push(
//       new Style({
//         geometry: new Point(start),
//         image: new Circle({
//           radius: 4,
//           stroke: new Stroke({
//             color: "rgba(0, 0, 0, 0.8)",
//             width: 2,
//           }),
//           fill: new Fill({
//             color: "rgba(255, 255, 255, 1)",
//           }),
//         }),
//       })
//     );
//     const end = geom.getLastCoordinate();
//     styles.push(
//       new Style({
//         geometry: new Point(end),
//         image: new Circle({
//           radius: 4,
//           stroke: new Stroke({
//             color: "rgba(0, 0, 0, 0.8)",
//             width: 2,
//           }),
//           fill: new Fill({
//             color: "rgba(255, 255, 255, 1)",
//           }),
//         }),
//       })
//     );
//     return styles;
//   },
// });

// const drawDistance = createInteraction({
//   interaction: "draw",
//   source: distanceLayer.getSource(),
//   type: "LineString",
// });

// const modifyDistance = createInteraction({
//   interaction: "modify",
//   source: distanceLayer.getSource(),
// });

// // SET UP AREA STUFF
// const areaLayer = getLayer({
//   serviceType: "LocalVector",
//   visible: true,
//   geometryType: "Polygon",
//   style: [
//     new Style({
//       stroke: new Stroke({
//         color: "rgba(255, 255, 255, 0.9)",
//         width: 4,
//       }),
//       fill: new Fill({
//         color: "rgba(255, 255, 255, 0.2)",
//       }),
//     }),
//     new Style({
//       stroke: new Stroke({
//         color: "rgba(0, 0, 0, 0.8)",
//         lineDash: [4, 4],
//         width: 2,
//       }),
//     }),
//   ],
// });

// const drawArea = createInteraction({
//   interaction: "draw",
//   source: areaLayer.getSource(),
//   type: "Polygon",
// });

// const modifyArea = createInteraction({
//   interaction: "modify",
//   source: areaLayer.getSource(),
// });




// START BUNDLE
export default {
  name: 'measure',

  getReducer(){
    const initialState = {
      shouldRemoveInteraction: false,
      shouldAddDrawLayers: false,
      active: false,
      distanceLayer: null,
      areaLayer: null,
      drawDistance: null,
      modifyDistance: null,
      drawArea: null,
      modifyArea: null,
      type: null,
      geom: null,
      areaUnits: 'ft/mi',
      distanceUnits: 'ft/mi'
    }

    return (state = initialState, { type, payload }) => {
      if(type === 'MEASURE_LAYERS_ADDED'){
        return Object.assign({}, state, payload)
      }
      if(type === 'MEASURE_STARTED'){
        return Object.assign({}, state, {
          active: true,
          type: payload.type
        })
      }
      if(type === 'MEASURE_DRAW_STARTED'){
        return Object.assign({}, state, {
          geom: payload.geom
        })
      }
      if(type === 'MEASURE_STOP'){
        return Object.assign({}, state, {
          shouldRemoveInteraction: false
        })
      }
      if(type === 'MEASURE_STOPPED'){
        return Object.assign({}, state, {
          active: false,
          type: null,
          geom: null
        })
      }
      if(type === 'MEASURE_STOPPED'){
        return Object.assign({}, state, {
          active: false,
          type: null,
          geom: null
        })
      }

      if(type === 'MEASURE_UNITS_UPDATED'){
        return Object.assign({}, state, payload);
      }

      if(type === 'MAP_CREATED'){
        return Object.assign({}, state, {shouldAddDrawLayers: true});
      }
      if(type === 'MAP_SWITCHED_DIMENSION'){
        return Object.assign({}, state, {shouldRemoveInteraction: payload.threeD});
      }
      
      return state;
    }

  },

  doStartMeasure: (type) => ({ dispatch, store }) => {
    store.doSetCursor('crosshair');
    if(type === 'distance'){
      store.doStartMeasureDistance();
    }else{
      store.doStartMeasureArea();
    }
    dispatch({type:'MEASURE_STARTED', payload:{type: type}});
  },
  doAddMeasureLayers:() => ({ dispatch, store }) => {
    dispatch({type:'MEASURE_LAYERS_ADDED', payload:{shouldAddDrawLayers:false}})
    const distanceLayer = getLayer({
      serviceType: 'LocalVector',
      visible: true,
      geometryType: 'LineString'
    })
    const areaLayer = getLayer({
      serviceType: 'LocalVector',
      visible: true,
      geometryType: 'Polygon'
    })
    const drawDistance = createInteraction({
      interaction:'draw', 
      source: distanceLayer.getSource(), 
      type: 'LineString',
    })
    
    const modifyDistance = createInteraction({
      interaction: 'modify',
      source: distanceLayer.getSource(), 
    })
    const drawArea = createInteraction({
      interaction: 'draw',
      source: areaLayer.getSource(),
      type: 'Polygon'
    })
    
    const modifyArea = createInteraction({
      interaction: 'modify',
      source: areaLayer.getSource()
    })
    dispatch({type:'MEASURE_LAYERS_ADDED', payload:{distanceLayer: distanceLayer, areaLayer:areaLayer, drawArea, modifyArea, drawDistance, modifyDistance}});
    
    
  },

  doStartMeasureDistance: () => ({ dispatch, store }) => {
    const map = store.selectMap();
    store.doStopMeasureArea();
    const distanceLayer = store.selectDistanceLayer();
    const drawDistance = store.selectDrawDistance();
    const modifyDistance = store.selectModifyDistance();
    map.addLayer(distanceLayer);
    map.addInteraction(drawDistance);
    map.addInteraction(modifyDistance);
    drawDistance.on('drawstart', store.doStartMeasureDraw);
    drawDistance.on('drawend', store.doStopMeasureDraw);
  },

  doStartMeasureArea: () => ({ dispatch, store }) => {
    const map = store.selectMap();
    store.doStopMeasureDistance();
    const areaLayer = store.selectAreaLayer();
    const drawArea = store.selectDrawArea();
    const modifyArea = store.selectModifyArea();
    map.addLayer(areaLayer);
    map.addInteraction(drawArea);
    map.addInteraction(modifyArea);
    drawArea.on('drawstart', store.doStartMeasureDraw);
    drawArea.on('drawend', store.doStopMeasureDraw);
  },

  doStartMeasureDraw: (e) => ({ dispatch, store }) => {
    store.doClearMeasureFeatures();
    const geom = e.feature.getGeometry();
    if(geom) geom.on('change', throttle(store.doUpdateDrawing, 200));
    dispatch({type:'MEASURE_DRAW_STARTED', payload: { geom: geom }});
  },

  doStopMeasureDraw: (e) => ({ dispatch, store }) => {
    dispatch({type:'MEASURE_DRAW_STOPPED'});
  },

  doUpdateDrawing: (e) => ({ dispatch, store }) => {
    dispatch({type:'MEASURE_DRAW_UPDATED'});
  },

  doPauseMeasure: () => ({ dispatch, store }) => {
    store.doSetCursor();
    const map = store.selectMap();
    const type = store.selectMeasureType();
    const drawDistance = store.selectDrawDistance();
    const modifyDistance = store.selectModifyDistance();
    const drawArea = store.selectDrawArea();
    const modifyArea = store.selectModifyArea();
    const draw = type === 'distance' ? drawDistance : drawArea;
    const modify = type === 'distance' ? modifyDistance : modifyArea;
    
    map.removeInteraction(draw);
    map.removeInteraction(modify);
  },

  doClearMeasureFeatures: () => ({ dispatch, store }) => {
    
    const areaLayer = store.selectAreaLayer();
    const distanceLayer = store.selectDistanceLayer();
    const dSrc = distanceLayer.getSource();
    const aSrc = areaLayer.getSource();
    dSrc.clear(true);
    aSrc.clear(true);
  },

  doStopMeasure: () => ({ dispatch, store }) => {
    dispatch({type:'MEASURE_STOP'});
    store.doClearMeasureFeatures();
    store.doSetCursor();
    store.doStopMeasureArea();
    store.doStopMeasureDistance();
    dispatch({type:'MEASURE_STOPPED'});
  },

  doStopMeasureArea: () => ({ dispatch, store }) => {
    const map = store.selectMap();
    const areaLayer = store.selectAreaLayer();
    const drawArea = store.selectDrawArea();
    const modifyArea = store.selectModifyArea();
    // drawArea.un('drawstart');
    // drawArea.un('drawend');
    map.removeInteraction(drawArea);
    map.removeInteraction(modifyArea);
    map.removeLayer(areaLayer);
  },

  doStopMeasureDistance: () => ({ dispatch, store }) => {
    const map = store.selectMap();
    const distanceLayer = store.selectDistanceLayer();
    const drawDistance = store.selectDrawDistance();
    const modifyDistance = store.selectModifyDistance();
    // drawDistance.un('drawstart');
    // drawDistance.un('drawend');
    map.removeInteraction(drawDistance);
    map.removeInteraction(modifyDistance);
    map.removeLayer(distanceLayer);
  },

  doUpdateMeasureUnits: ({ areaUnits, distanceUnits }) => ({ dispatch }) => {
    dispatch({type: 'MEASURE_UNITS_UPDATED', payload: { areaUnits, distanceUnits }});
  },
  selectDrawDistance: (state) => {
    return state.measure.drawDistance;
  },
  selectModifyDistance: (state) => {
    return state.measure.modifyDistance;
  },
  selectDrawArea: (state) => {
    return state.measure.drawArea;
  },
  selectModifyArea: (state) => {
    return state.measure.modifyArea;
  },
  selectAreaLayer: (state) => {
    return state.measure.areaLayer;
  },
  selectDistanceLayer: (state) => {
    return state.measure.distanceLayer;
  },
  selectMeasureType: (state) => {
    return state.measure.type;
  },

  selectMeasureAreaUnits: (state) => {
    return state.measure.areaUnits;
  },

  selectMeasureDistanceUnits: (state) => {
    return state.measure.distanceUnits;
  },

  selectMeasureGeom: (state) => {
    return state.measure.geom;
  },

  selectMeasureOutput: createSelector(
    'selectMeasureGeom',
    'selectMeasureType',
    'selectMapProjection',
    'selectMeasureAreaUnits',
    'selectMeasureDistanceUnits',
    'selectAppTime',
    (geom, type, mapProjection, areaUnits, distanceUnits, appTime) => {
      if(!geom) return {output:'...',value:0};
      const projected = geom.clone().transform(mapProjection, 'EPSG:4326');
      if(type === 'distance'){
        const coords = projected.getCoordinates();
        let length = 0;
        for(var i = 0; i < coords.length - 1; i++){
          length += getDistance(coords[i], coords[i+1]);
        }
        return convertDistance(length, distanceUnits);
      }else{
        const coords = projected.getLinearRing(0).getCoordinates();
        if(coords.length > 3) return convertArea(Math.abs(getArea(geom)), areaUnits);
        return {output:'...',value:0};
      }
    }
  ),

  selectMeasureSettings: (state) => {
    return state.measure;
  },
  reactMeasureShouldLoadLayers: (state) => {
    if(state.measure.shouldAddDrawLayers) return { actionCreator: 'doAddMeasureLayers' };
  },
  reactMeasureShouldRemoveInteraction: (state) => {
    if(state.measure.shouldRemoveInteraction) return { actionCreator: 'doStopMeasure' };
  },
}